import React from 'react';
import { Button, Tooltip } from '@planne-software/uni';
import { IconCalendarMonth } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

export type RescheduleTriggerButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  /** Shown when the button is disabled because the reservation belongs to a package. */
  tooltip?: string;
};

export const RescheduleTriggerButton = (props: RescheduleTriggerButtonProps) => {
  const { onClick, disabled = false, tooltip } = props;
  const { i18n } = useTranslate();

  const button = (
    <Button
      data-testid='reschedule-trigger'
      variant='outlined'
      size='sm'
      disabled={disabled}
      onClick={onClick}
      startSlot={<IconCalendarMonth size={20} aria-hidden />}
    >
      {i18n('checkout_confirmed_reschedule')}
    </Button>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip arrow placement='top' label={tooltip}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default RescheduleTriggerButton;
